<button pButton 
    class="p-button-rounded p-button-help sticky-v4-btn"
    icon="pi pi-question-circle"
    (click)="display=true"
    style="position: fixed; bottom: 20px; left: 20px; z-index: 1000;">
</button>

<p-dialog [style]="{ width:'92vw', maxWidth:'1000px'}" header="{{'Tutorial Video' | translator}}" [(visible)]="display"  [modal]="true">
    <video #videoPlayer width="100%" controls>
        <source src="assets/kGate_tutorial.webm" type="video/mp4">
        {{"Your browser does not support the video tag." | translator }}
    </video>
    
    <ng-template pTemplate="footer">
        <button class="v4-btn-every" (click)="display=false">{{'Close' | translator}}</button>
        <!-- <button class="mmmmm" pButton type="button" label="{{'Close' | translator}}" (click)="display=false"></button> -->
    </ng-template>
</p-dialog>